import { render, staticRenderFns } from "./profile-card.vue?vue&type=template&id=4c7f7186&scoped=true&"
import script from "./profile-card.vue?vue&type=script&lang=js&"
export * from "./profile-card.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c7f7186",
  null
  
)

export default component.exports